import format from "date-fns/format"

export const availableTime = (time, availableTimes) => {
  const formattedTime = format(time, "HH:mm")

  return availableTimes.includes(formattedTime)
}
